/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Defects_Return_To_Sorting_Disabled_TooltipInputs */

const vi_warehouse_defects_return_to_sorting_disabled_tooltip = /** @type {(inputs: Warehouse_Defects_Return_To_Sorting_Disabled_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tính năng khả dụng sau khi xong Kho phân loại.`)
};

/**

* @param {Warehouse_Defects_Return_To_Sorting_Disabled_TooltipInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_defects_return_to_sorting_disabled_tooltip = /** @type {((inputs?: Warehouse_Defects_Return_To_Sorting_Disabled_TooltipInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Defects_Return_To_Sorting_Disabled_TooltipInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_defects_return_to_sorting_disabled_tooltip(inputs)
});